import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/ui/Logo';
import { useI18n } from '../i18n/I18nContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { content } = useI18n();
  const footer = content.footer;

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Logo size={30} showText />
          <p>{footer.description}</p>
        </div>
        <div className="footer__links">
          <div>
            <h2>{footer.explore}</h2>
            {footer.exploreLinks.map(link => <Link key={link.href} to={link.href}>{link.label}</Link>)}
          </div>
          <div>
            <h2>{footer.company}</h2>
            {footer.companyLinks.map(link => <Link key={link.href} to={link.href}>{link.label}</Link>)}
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <span>© {new Date().getFullYear()} AssetFactory</span>
          <span>assetfactory.app</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
